import { LoadingActionTypes, LoadingActionsUnion } from './actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface LoadingState {
    loading: boolean;
}

export const initialState: LoadingState = {
    loading: false
};

export function reducer(
    state: LoadingState = initialState,
    action: LoadingActionsUnion
): LoadingState {
    switch (action.type) {
        case LoadingActionTypes.SetLoading:
            return {
                ...state,
                loading: action.payload
            };
        default:
            return state;
    }
}

const loadingState = createFeatureSelector<LoadingState>('loading');
export const getLoading = createSelector(loadingState, x => x.loading);
